import React from "react";
import NestedAccordion from "./NestedAccordion";
import NestedAccordionBody from "./NestedAccordionBody";
import NestedAccordionIcon from "./NestedAccordionIcon";
import NestedAccordionHeader from "./NestedAccordionHeader";

const NestedAccordionItem = ({
    col,
    columns,
    colIndex,
    mobileView,
    element,
    ID,
    showAddElement,
    disableRowTool,
    tool,
    onAddElementorColumnInColumn,
    onAddElementorColumn,
    openAndCloseAccordionItems,
    openAccordionItems,
    selectedFont,
    pagesList,
    cloneElement,
    deleteElement,
    preset,
    openAccordionItemSettingsIndex,
    toggleAccordionItemSettings,
    userId,
    sessionId,
    addRemoveColumn
}) => {
    return (
        <div
            className={"accordion-item"}
            style={
                mobileView
                    ? {
                        backgroundColor: openAccordionItems.includes(col)
                            ? `rgba(${element.columnSettings[col].itemHeader.mobileStyle.expandedBackgroundColor.r},${element.columnSettings[col].itemHeader.mobileStyle.expandedBackgroundColor.g},${element.columnSettings[col].itemHeader.mobileStyle.expandedBackgroundColor.b},${element.columnSettings[col].itemHeader.mobileStyle.expandedBackgroundColor.a})`
                            : `rgba(${element.columnSettings[col].itemHeader.mobileStyle.backgroundColor.r},${element.columnSettings[col].itemHeader.mobileStyle.backgroundColor.g},${element.columnSettings[col].itemHeader.mobileStyle.backgroundColor.b},${element.columnSettings[col].itemHeader.mobileStyle.backgroundColor.a})`,

                        height: "auto",
                        borderStyle: "solid",
                        borderColor: `rgba(${element.columnSettings[col].itemHeader.mobileStyle.borderColor.r},${element.columnSettings[col].itemHeader.mobileStyle.borderColor.g},${element.columnSettings[col].itemHeader.mobileStyle.borderColor.b},${element.columnSettings[col].itemHeader.mobileStyle.borderColor.a})`,
                        borderWidth:
                            element.columnSettings[col].itemHeader.mobileStyle.borderWidth +
                            "px",
                        borderRadius:
                            element.columnSettings[col].itemHeader.mobileStyle
                                .borderRadius + "px",
                    }
                    : {
                        backgroundColor: openAccordionItems.includes(col)
                            ? `rgba(${element.columnSettings[col].itemHeader.desktopStyle.expandedBackgroundColor.r},${element.columnSettings[col].itemHeader.desktopStyle.expandedBackgroundColor.g},${element.columnSettings[col].itemHeader.desktopStyle.expandedBackgroundColor.b},${element.columnSettings[col].itemHeader.desktopStyle.expandedBackgroundColor.a})`
                            : `rgba(${element.columnSettings[col].itemHeader.desktopStyle.backgroundColor.r},${element.columnSettings[col].itemHeader.desktopStyle.backgroundColor.g},${element.columnSettings[col].itemHeader.desktopStyle.backgroundColor.b},${element.columnSettings[col].itemHeader.desktopStyle.backgroundColor.a})`,

                        height: "auto",
                        borderStyle: "solid",
                        borderColor: `rgba(${element.columnSettings[col].itemHeader.desktopStyle.borderColor.r},${element.columnSettings[col].itemHeader.desktopStyle.borderColor.g},${element.columnSettings[col].itemHeader.desktopStyle.borderColor.b},${element.columnSettings[col].itemHeader.desktopStyle.borderColor.a})`,
                        borderWidth:
                            element.columnSettings[col].itemHeader.desktopStyle
                                .borderWidth + "px",
                        borderRadius:
                            element.columnSettings[col].itemHeader.desktopStyle
                                .borderRadius + "px",
                    }
            }
        >
            <NestedAccordionHeader
                openAndCloseAccordionItems={openAndCloseAccordionItems}
                openAccordionItems={openAccordionItems}
                variableStyles={
                    mobileView
                        ? {
                            paddingTop:
                                element.columnSettings[col].itemHeader.mobileStyle
                                    .paddingTop +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingBottom:
                                element.columnSettings[col].itemHeader.mobileStyle
                                    .paddingBottom +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingRight:
                                element.columnSettings[col].itemHeader.mobileStyle
                                    .paddingRight +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingLeft:
                                element.columnSettings[col].itemHeader.mobileStyle
                                    .paddingLeft +
                                element.columnSettings[col].itemHeader.paddingUnit,
                        }
                        : {
                            paddingTop:
                                element.columnSettings[col].itemHeader.desktopStyle
                                    .paddingTop +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingBottom:
                                element.columnSettings[col].itemHeader.desktopStyle
                                    .paddingBottom +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingRight:
                                element.columnSettings[col].itemHeader.desktopStyle
                                    .paddingRight +
                                element.columnSettings[col].itemHeader.paddingUnit,
                            paddingLeft:
                                element.columnSettings[col].itemHeader.desktopStyle
                                    .paddingLeft +
                                element.columnSettings[col].itemHeader.paddingUnit,
                        }
                }
                title={
                    <p
                        style={
                            mobileView
                                ? {
                                    color: `rgba(${element.columnSettings[col].itemHeader.mobileStyle.color.r},${element.columnSettings[col].itemHeader.mobileStyle.color.g},${element.columnSettings[col].itemHeader.mobileStyle.color.b},${element.columnSettings[col].itemHeader.mobileStyle.color.a})`,
                                    fontFamily:
                                        element.columnSettings[col].itemHeader.mobileStyle
                                            .fontFamily,
                                    fontSize:
                                        element.columnSettings[col].itemHeader.mobileStyle
                                            .fontSize + "px",

                                    fontWeight:
                                        element.columnSettings[col].itemHeader.mobileStyle
                                            .fontBold === true
                                            ? "bold"
                                            : "normal",
                                }
                                : {
                                    color: `rgba(${element.columnSettings[col].itemHeader.desktopStyle.color.r},${element.columnSettings[col].itemHeader.desktopStyle.color.g},${element.columnSettings[col].itemHeader.desktopStyle.color.b},${element.columnSettings[col].itemHeader.desktopStyle.color.a})`,
                                    fontFamily:
                                        element.columnSettings[col].itemHeader.desktopStyle
                                            .fontFamily,
                                    fontSize:
                                        element.columnSettings[col].itemHeader.desktopStyle
                                            .fontSize + "px",
                                    fontWeight:
                                        element.columnSettings[col].itemHeader.desktopStyle
                                            .fontBold === true
                                            ? "bold"
                                            : "normal",
                                }
                        }
                    >
                        {element.columnSettings[col].itemHeader.title}
                    </p>
                }
                icon={
                    <NestedAccordionIcon
                        itemOpen={openAccordionItems.includes(col)}
                        iconColor={
                            mobileView
                                ? element.columnSettings[col].itemHeader.mobileStyle.iconColor
                                : element.columnSettings[col].itemHeader.desktopStyle.iconColor
                        }
                        iconStyle={
                            mobileView
                                ? element.accordion.mobileStyle.iconType
                                : element.accordion.desktopStyle.iconType
                        }
                    />
                }
                onClick={(e) => {
                    e.preventDefault();
                    openAndCloseAccordionItems(col);
                }}
                targetId={`${colIndex}`}
            />

            {openAccordionItems.includes(col) && (
                <NestedAccordionBody
                    key={"accordion_body" + colIndex}
                    userId={userId}
                    sessionId={sessionId}
                    selectedFont={selectedFont}
                    pagesList={pagesList}
                    element={element}
                    col={col}
                    columns={columns}
                    colIndex={colIndex}
                    ID={ID}
                    disableRowTool={disableRowTool}
                    showAddElement={showAddElement}
                    tool={tool}
                    onAddElementorColumnInColumn={onAddElementorColumnInColumn}
                    onAddElementorColumn={onAddElementorColumn}
                    AccordionItems={openAndCloseAccordionItems}
                    accordionId={`${colIndex}`}
                    cloneElement={cloneElement}
                    deleteElement={deleteElement}
                    preset={preset}
                    openAccordionItemSettingsIndex={openAccordionItemSettingsIndex}
                    toggleAccordionItemSettings={toggleAccordionItemSettings}
                    mobileView={mobileView}
                    addRemoveColumn={addRemoveColumn}
                />
            )}
        </div>
    );
};

export default NestedAccordionItem;
